<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Output",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Output ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Output",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODCUT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "user",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "date",
          sortable: true,
          label: "ADDED ON",
        },
        {
          key: "actions",
          sortable: true,
          label: "ACTIONS",
        }
        
      ],

      // Value from user input for adding unit
      confirmdata: {
        product: "",
        id: "",
      },
      // edit unit
      editdata: {
        product: "",
        id: "",
        quantity: "",
      },
      // delete unit
      deletedata: {
        product: "",
        id: "",
      },
      QuantityError:"",
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("recipes", ["SaveStatus","ExpectedOutput","ActualOutput"]),
    ...mapGetters("auth",["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ExpectedOutput ? this.ExpectedOutput.length : 1;
    },

    rows2() {
      return this.ActualOutput ? this.ActualOutput.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchExpectedOutput: "recipes/fetchExpectedOutput",
      FetchActualOutput: "recipes/fetchActualOutput",
      EditOutput: "recipes/editOutput",
      DeleteOutput: "recipes/deleteOutput",
      ConfirmOutput: "recipes/confirmOutput",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });    
    },

    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.product = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.QuantityError = "";
    },

    resetConfirm() {
      this.confirmdata.product = "";
      this.confirmdata.id = "";
      this.modal_id = "";
    },

    showEditModal(data) {
      this.editdata.product = data.product;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
    },

    showDeleteModal(data) {
      this.deletedata.product = data.product;
      this.deletedata.id = data.id;
    },

    showConfirmModal(data) {
      this.confirmdata.product = data.product;
      this.confirmdata.id = data.id;
    },

    editOutput(modalId) {
      this.modal_id = modalId;
      this.EditOutput(this.editdata);
    },

    deleteOutput(modalId) {
      this.modal_id = modalId;
      this.DeleteOutput(this.deletedata);
    },

    confirmOutput(modalId) {
      this.modal_id = modalId;
      this.ConfirmOutput(this.confirmdata);
    },

  },
  created() {    
    this.FetchExpectedOutput();
    this.FetchActualOutput();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="p-3 text-muted">
                <b-tab active class="border-0">
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Expected Output</span>
                    </template>
                    <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                        <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                        </label>
                        </div>
                    </div>

                    <div class="col-md-4">
                      
                    </div>

                    <!-- Search -->
                    <div class="col-sm-12 col-md-4">
                        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                            ></b-form-input>
                        </label>
                        </div>
                    </div>
                    <!-- End search -->
                    </div>
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="ExpectedOutput?ExpectedOutput:[]"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                    >
                    <template #cell(index)="data">
                    {{ data.index + 1 }}
                    </template>
                    <template #cell(quantity)="data">
                        {{ (data.item.quantity) }} {{ (data.item.unit) }}
                    </template>
                    <template #cell(actions)="data">
                        <b-button-group>
                            <b-button
                                v-if="MyUserPerm.edit_expected_output && data.item.status == 0"
                                size="sm"
                                variant="primary"
                                v-b-modal.edit-item-modal
                                @click="showEditModal(data.item)"
                            ><i class="fa fa-edit"></i></b-button>
                            <b-button
                                v-if="MyUserPerm.delete_expected_output && data.item.status == 0"
                                v-b-modal.delete-item-modal
                                variant="danger"
                                size="sm"
                                @click="showDeleteModal(data.item)"
                            ><i class="fa fa-trash"></i></b-button>                            
                            <b-button
                                v-if="MyUserPerm.confirm_expected_output && data.item.status == 0"
                                v-b-modal.confirm-modal
                                variant="success"
                                size="sm"
                                @click="showConfirmModal(data.item)"
                            ><i class="fa fa-check"></i>Confirm</b-button>  
                            <button
                                v-if="MyUserPerm.confirm_expected_output && data.item.status == 1"
                                class="btn btn-link"                                
                                variant="info"
                                size="sm"
                            >Confirmed</button>                            
                        </b-button-group>
                    </template>
                    </b-table>
                    <!-- modal cofirm output starts -->
                    <b-modal
                    header-bg-variant="warning"
                    header-text-variant="light"
                    body-text-variant="warning"
                    footer-bg-variant="warning"
                    footer-text-variant="warning"
                    id="confirm-modal"
                    hide-footer
                    @hidden="resetConfirm()"
                    >
                    <template #modal-title> Confirm output for <small><em>{{ confirmdata.product }}</em></small></template>
                    <div class="form-group mb-2">
                        <div class="input-group">
                        <h5>
                            You are confirming out for <em class="text-warning">{{ confirmdata.product }}</em> ? Click Proceed Button to continue.
                        </h5>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="closeModal('confirm-modal')"
                        >
                        <i class="fa fa-times"></i> Close
                        </button>
                        <button
                        type="button"
                        class="btn btn-primary"
                        @click="confirmOutput('confirm-modal')"
                        >
                        <i class="fa fa-cog"></i> Proceed
                        <b-spinner
                            v-if="SaveStatus"
                            variant="light"
                            small
                            label="Changing"
                        ></b-spinner>
                        </button>
                    </div>
                    </b-modal>
                    <!-- modal ends -->

                    <!-- modal edit output starts -->
                    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()" class="text-primary">
                    <template #modal-title>
                        Edit output for product {{ editdata.product }}</template
                    >
                    <div class="form-group mb-3">
                        <label>Quantity</label>
                        <input
                            type="number"
                            class="form-control"
                            step="any"
                            v-model="editdata.quantity"
                        />
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-danger"
                            data-dismiss="modal"
                            @click="closeModal('edit-item-modal')"
                        >
                        <i class="fa fa-times"></i> Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="editOutput('edit-item-modal')"
                        >
                        <i class="fa fa-check"></i> Save Changes
                        <b-spinner
                            v-if="SaveStatus"
                            variant="light"
                            small
                            label="Deleting"
                        ></b-spinner>
                        </button>
                    </div>
                    </b-modal>
                    <!-- modal ends -->
                    <!-- modal delete output starts -->
                    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" class="text-danger">
                    <template #modal-title> Delete output for product {{ deletedata.product }}</template>
                    <div class="form-group mb-3">
                        <div class="input-group">
                        <h5>Do you want to delete this output? Click Proceed to continue.</h5>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="closeModal('delete-item-modal')"
                        >
                        <i class="fa fa-times"></i> Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            @click="deleteOutput('delete-item-modal')"
                        >
                        <i class="fa fa-trash"></i> Proceed
                        <b-spinner
                            v-if="SaveStatus"
                            variant="light"
                            small
                            label="Deleting"
                        ></b-spinner>
                        </button>
                    </div>
                    </b-modal>
                    <!-- modal ends -->
                    </div>
                    <Loader  v-if="!ExpectedOutput"/>
                    <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end"
                        >
                        <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                        </div>
                    </div>
                    </div>
                </b-tab>
                <b-tab class="border-0">
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Actual Output</span>
                    </template>
                    <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                        <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                        </label>
                        </div>
                    </div>

                    <div class="col-4"></div>

                    <!-- Search -->
                    <div class="col-sm-12 col-md-4">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                            ></b-form-input>
                        </label>
                        </div>
                    </div>
                    <!-- End search -->
                    </div>
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="ActualOutput?ActualOutput:[]"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                    >
                        <template #cell(index)="data">
                        {{ data.index + 1 }}
                        </template>
                        <template #cell(product)="data">
                            {{ (data.item.product) }} {{ (data.item.unit) }}
                        </template>
                        <template #cell(actions)="">
                            <b-button-group>
                                <button
                                    class="btn btn-link"                                
                                    variant="info"
                                    size="sm"
                                >Confirmed</button>                            
                            </b-button-group>
                        </template>
                    </b-table>
                    </div>
                    <Loader  v-if="!ActualOutput"/>
                    <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end"
                        >
                        <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows2"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                        </div>
                    </div>
                    </div>
                </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
